<script lang="ts">
  // Time field that accepts quick input: "9" → 09:00, "930" → 09:30, "13.15" → 13:15.
  import { parseTimeInput } from '../format';
  import '../messages/ui';
  import { t } from '../i18n.svelte';

  interface Props {
    value?: string; // 'HH:MM'
    placeholder?: string;
    disabled?: boolean;
    invalid?: boolean;
    id?: string;
    ariaLabel?: string;
    onchange?: (value: string) => void;
    class?: string;
  }
  let { value = $bindable(''), placeholder, disabled = false, invalid = false, id, ariaLabel, onchange, class: cls = '' }: Props = $props();
  let text = $state('');
  let focused = $state(false);
  let bad = $state(false);

  $effect(() => {
    if (!focused) text = value || '';
  });

  function commit() {
    focused = false;
    if (!text.trim()) {
      bad = false;
      if (value !== '') {
        value = '';
        onchange?.('');
      }
      return;
    }
    const parsed = parseTimeInput(text);
    if (!parsed) {
      bad = true;
      return;
    }
    bad = false;
    text = parsed;
    if (parsed !== value) {
      value = parsed;
      onchange?.(parsed);
    }
  }
</script>

<input
  {id}
  class="control time {cls}"
  class:invalid={invalid || bad}
  type="text"
  inputmode="numeric"
  autocomplete="off"
  aria-label={ariaLabel}
  placeholder={placeholder ?? t('ui.time_placeholder')}
  {disabled}
  bind:value={text}
  onfocus={(e) => {
    focused = true;
    (e.currentTarget as HTMLInputElement).select();
  }}
  onblur={commit}
  onkeydown={(e) => e.key === 'Enter' && commit()}
/>

<style>
  .time { font-variant-numeric: tabular-nums; text-align: center; max-width: 100%; }
</style>
